/* Dutch'D mega menu (replaces the Globo Mega Menu app) */
(function () {
  if (window.__ddMegaMenu) return;
  window.__ddMegaMenu = true;

  var OPEN_DELAY = 70;
  var CLOSE_DELAY = 180;

  function init() {
    var items = document.querySelectorAll('[data-ddmm-item]');
    if (!items.length) return;

    var portal = document.querySelector('.dd-mm-portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.className = 'dd-mm-portal';
      document.body.appendChild(portal);
    }
    var header = document.querySelector('[data-header-height]') || document.querySelector('.theme__header');
    var current = null;
    var openTimer = null;
    var closeTimer = null;
    var lastPointer = 'mouse';
    var lastWidth = window.innerWidth;

    function headerBottom() {
      if (!header) return 0;
      return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }
    function setTop() {
      portal.style.setProperty('--ddmm-top', headerBottom() + 'px');
    }
    function open(entry) {
      clearTimeout(closeTimer);
      if (current === entry) return;
      if (current) hide(current, true);
      current = entry;
      setTop();
      entry.panel.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { entry.panel.classList.add('is-open'); });
      });
      entry.item.classList.add('dd-mm--open');
      entry.link.setAttribute('aria-expanded', 'true');
    }
    function hide(entry, instant) {
      entry.panel.classList.remove('is-open');
      entry.item.classList.remove('dd-mm--open');
      entry.link.setAttribute('aria-expanded', 'false');
      if (current === entry) current = null;
      if (instant) {
        entry.panel.hidden = true;
      } else {
        setTimeout(function () { if (current !== entry) entry.panel.hidden = true; }, 160);
      }
    }
    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { if (current) hide(current); }, CLOSE_DELAY);
    }
    function cancelClose() { clearTimeout(closeTimer); }

    Array.prototype.forEach.call(items, function (item) {
      var panel = item.querySelector('[data-ddmm-panel]');
      var link = item.querySelector('[data-top-link]');
      if (!panel || !link) return;
      portal.appendChild(panel);
      var entry = { item: item, panel: panel, link: link };

      item.addEventListener('mouseenter', function () {
        if (lastPointer !== 'mouse') return;
        cancelClose();
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(entry); }, current ? 0 : OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function () { if (lastPointer === 'mouse') scheduleClose(); });
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', function () { if (lastPointer === 'mouse') scheduleClose(); });

      link.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
      link.addEventListener('click', function (e) {
        if (lastPointer !== 'mouse' && current !== entry) {
          e.preventDefault();
          open(entry);
        }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          open(entry);
          var first = panel.querySelector('a');
          if (first) setTimeout(function () { first.focus(); }, 30);
        } else if (e.key === 'Escape') {
          hide(entry, true);
        }
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          hide(entry, true);
          link.focus();
        }
      });
      panel.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !panel.contains(e.relatedTarget) && e.relatedTarget !== link) hide(entry, true);
      });
    });

    document.addEventListener('pointerdown', function (e) {
      lastPointer = e.pointerType || 'mouse';
      if (!current) return;
      if (current.panel.contains(e.target) || current.item.contains(e.target)) return;
      hide(current, true);
    });
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') lastPointer = 'mouse';
    }, { passive: true });
    window.addEventListener('scroll', function () { if (current) setTop(); }, { passive: true });
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) { if (current) setTop(); return; }
      lastWidth = window.innerWidth;
      if (current) hide(current, true);
    });
    document.addEventListener('theme:drawer:open', function () { if (current) hide(current, true); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
